export default __webpack_public_path__ + "static/media/user-edit.10e7fc65.svg";